import { render } from "./BlockButtons.vue?vue&type=template&id=14076a92&ts=true"
import script from "./BlockButtons.vue?vue&type=script&lang=ts"
export * from "./BlockButtons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__